import { FragmentHandler } from './utils/FragmentHandler';
import { getLanguagePathPrefix } from './utils/getLanguagePathPrefix';
const saferRelativeOrigin = (origin = '') => {
    if (typeof window === 'undefined') {
        return origin;
    }
    return origin === window.location.origin ? '' : origin;
};
const integrationUrl = ({ fn, fragments, origin, }) => `${saferRelativeOrigin(origin)}${getLanguagePathPrefix(fragments.language)}/oauth/integration/?#${FragmentHandler.stringify('', Object.assign({ fn }, fragments))}`;
export const buildLoginWithScopeUrl = ({ origin, realm, scope = [], returnUri, language = '', } = {}) => integrationUrl({
    fn: 'loginWithScope',
    fragments: {
        realm,
        return_uri: returnUri,
        scope: scope.join(' '),
        language,
    },
    origin,
});
export const loginWithScopeUrl = buildLoginWithScopeUrl;
export const buildLoginUrl = ({ location: inputLocation, language, } = {}) => {
    const { pathname = '', search = '', origin = '', } = inputLocation || (typeof window !== 'undefined' ? window.location : {});
    const params = {
        returnPath: pathname + search,
    };
    const qs = new URLSearchParams(params).toString();
    return `${saferRelativeOrigin(origin)}${getLanguagePathPrefix(language)}/oauth/login/${qs ? `?${qs}` : ''}`;
};
export const buildLogoutUrl = ({ origin, returnPath, language, } = {}) => {
    const params = {};
    if (returnPath) {
        params.returnPath = returnPath;
    }
    const qs = new URLSearchParams(params).toString();
    return `${saferRelativeOrigin(origin)}${getLanguagePathPrefix(language)}/oauth/logout/${qs ? `?${qs}` : ''}`;
};
//# sourceMappingURL=oauth.js.map